import { Component, ViewEncapsulation } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { QItem } from '@app/cp/shared/models/QItem';

@Component({
    selector: 'inventory-locations',
    templateUrl: './inventory-locations.component.html',
    styleUrls: ['./inventory-locations.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InventoryLocationsComponent extends BaseGridUIComponent<QItem, null, InventoryService> {

    constructor(globals: GlobalsService, svc_data: InventoryService) {
        super(globals);
        this.svc_data = svc_data;
        
    }

}
